// Default motivational quotes (Italian). Users can edit these in Impostazioni.
export const DEFAULT_QUOTES = [
  "Fatto è meglio che perfetto.",
  "Un passo alla volta è comunque avanti.",
  "La calma è una forma di produttività.",
  "Comincia da dove sei, con quello che hai.",
  "Le giornate ordinarie costruiscono le vite straordinarie.",
  "Non serve fare tutto: serve fare le cose giuste.",
  "Il tempo che dedichi a ciò che conta non è mai perso.",
  "Piccoli gesti, ripetuti, diventano risultati.",
  "Respira. Poi scegli la prossima cosa.",
  "La lentezza è una scelta, non un ritardo.",
  "Meno cose, fatte meglio.",
  "Finito è meglio di perfetto.",
  "Ogni giorno è una pagina nuova.",
  "Ciò che coltivi ogni giorno cresce.",
  "Sii gentile con te stessa mentre progredisci.",
  "La costanza batte l'intensità.",
  "Puoi fare cose difficili.",
  "L'ordine fuori aiuta l'ordine dentro.",
  "Onora il tuo ritmo.",
  "Non tutto va risolto oggi.",
  "Il riposo fa parte del lavoro.",
  "Semplifica: togli ciò che non serve.",
  "Presenta te stessa alla giornata con curiosità.",
  "Ciò a cui presti attenzione, cresce.",
  "Le tue priorità dicono chi sei.",
  "Fatto oggi è meglio di perfetto domani.",
  "Chiedi aiuto quando serve, è forza.",
  "Ogni piccolo sì a te stessa è un investimento.",
  "Rallenta per andare più lontano.",
  "Metti prima le cose importanti.",
  "Il tuo tempo è la tua vita.",
  "Focalizzati, poi festeggia.",
  "Un buon inizio è già mezzo lavoro.",
  "Sorridi alla lista, non è il tuo padrone.",
  "Meglio in movimento che ferma nel dubbio.",
  "L'80% oggi vale più del 100% mai.",
  "Ricordati di alzare gli occhi dallo schermo.",
  "Bere acqua, respirare, ricominciare.",
  "Chiudere è meglio che aprire di nuovo.",
  "Un giorno alla volta, un compito alla volta.",
  "Le pause fanno parte del piano.",
  "Ordine gentile, mente leggera.",
  "Ricomincia quante volte serve, senza dramma.",
  "Ciò che rimandi ti pesa: fallo o cancellalo.",
  "Tempo leggero: fai spazio a ciò che ami.",
  "Un pensiero grato, una cosa fatta, un respiro lungo.",
  "La direzione conta più della velocità.",
  "Cerca il progresso, non l'approvazione.",
  "Sii la persona che avresti voluto avere accanto.",
  "Oggi hai il permesso di fare abbastanza."
];

export const DEFAULT_AFFIRMATIONS = [
  "Scelgo con calma e agisco con decisione.",
  "Ho tempo per ciò che conta davvero.",
  "Il mio ritmo è giusto per me.",
  "Sono capace di iniziare, anche in piccolo.",
  "Onoro la mia energia e la uso con cura.",
  "Riconosco i miei progressi, anche quelli invisibili.",
  "Faccio spazio alla gioia dentro la giornata.",
  "Merito riposo tanto quanto merito risultati.",
  "Le mie priorità meritano il mio tempo migliore.",
  "Sono presente a ciò che sto facendo, adesso.",
  "Chiudo con gentilezza ciò che ho aperto.",
  "Mi permetto di dire di no per dire sì a me.",
  "Ogni respiro è un nuovo inizio possibile.",
  "Sono più della mia lista di cose da fare.",
  "Trasformo l'ansia in un piano piccolo e chiaro.",
  "La mia calma è una risorsa preziosa.",
  "Scelgo la costanza al posto della perfezione.",
  "Coltivo abitudini che mi somigliano.",
  "Sono grata per il tempo che ho oggi.",
  "Vado dove va la mia attenzione: la scelgo bene."
];

// Pick a stable item based on a string seed (deterministic per day/week).
export function pickForSeed(list, seed) {
  if (!list || list.length === 0) return "";
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  return list[hash % list.length];
}
